import { connect } from 'react-redux'
import { IStoreState } from '../../types/index'
import ServiceViewMainInfo from '../../components/services/view/ServiceViewMainInfo'
import { getService, getServiceFetching, getServiceFetchingError } from '../../state/reducers/services'
import { getServiceProgram } from '../../state/reducers/service-program/service-program'

const mapStateToProps = (state: IStoreState, ownProps: any) => {
  const service = getService(state, ownProps.serviceId)
  let serviceProgram
  if (service && service.serviceProgram) {
    serviceProgram = getServiceProgram(state, service.serviceProgram)
  }

  return {
    service,
    serviceProgram,
    serviceId: ownProps.serviceId,
    fetching: getServiceFetching(state),
    fetchingError: getServiceFetchingError(state)
  }
}

const mapDispatchToProps = (dispatch: any) => {
  return {}
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ServiceViewMainInfo)



// WEBPACK FOOTER //
// ./src/containers/services/ServiceViewMainInfo.ts